import { render, staticRenderFns } from "./PostaCellChannels.vue?vue&type=template&id=7f6b7d56&scoped=true"
import script from "./PostaCellChannels.vue?vue&type=script&lang=js"
export * from "./PostaCellChannels.vue?vue&type=script&lang=js"
import style0 from "./PostaCellChannels.vue?vue&type=style&index=0&id=7f6b7d56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6b7d56",
  null
  
)

export default component.exports